import React from 'react';
import { useTranslation } from 'react-i18next';
import { DialogConfirmation } from '../../../../components/dialog/confirmation';
import { getAppName } from '../../../../utils/helpers';
import { LocationViews } from '../../types';
import { useLocationContext } from '../location/context/location.context';

type RemoveLocationProps = {
  show: boolean;
  setShow: (show: boolean) => void;
  onConfirm: () => void;
};

const RemoveLocation: React.FC<RemoveLocationProps> = ({ show, setShow, onConfirm }) => {
  const { t } = useTranslation('installation');
  const { t: tc } = useTranslation('common');
  const { goTo } = useLocationContext();

  const onClose = () => setShow(false);

  const goLearn = () => goTo(LocationViews.LEARN_REMOVE_LOCATION);

  const appName = getAppName();

  return (
    <DialogConfirmation
      show={show}
      setShow={onClose}
      header={t('locationRemovePopup')}
      secondaryBtnText={tc('buttons.cancel')}
      primaryBtnText={t('locationRemove')}
      secondaryBtnAction={onClose}
      primaryBtnAction={onConfirm}
      direction="column"
    >
      <>
        {t('locationRemoveMessage', { appName })}
        <span onClick={goLearn}>{t('learnMore')}.</span>
      </>
    </DialogConfirmation>
  );
};

export default RemoveLocation;
